"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const webfontloader_1 = __importDefault(require("webfontloader"));
const Provider_1 = __importDefault(require("./helpers/Provider"));
exports.Provider = Provider_1.default;
webfontloader_1.default.load({
    google: {
        families: ["Noto Sans:400,600,700", "Work Sans:400,500,600,700"],
    },
});
